export default __webpack_public_path__ + "static/media/Login.1c244577.png";